(function () {
  'use strict';

  // Een pagina kan deze sectie meer dan eens bevatten. Daarom querySelectorAll
  // in plaats van querySelector, alle selectors binnen de eigen section-root,
  // en een vlag per root tegen dubbele initialisatie.
  var FLAG = 'nxCatInit';

  function roots(scope) {
    var node = scope || document;
    var found = [];
    if (node.nodeType === 1 && node.matches && node.matches('[data-nx-cat]')) found.push(node);
    Array.prototype.push.apply(found, node.querySelectorAll('[data-nx-cat]'));
    return found;
  }

  function init(root) {
    if (root.dataset[FLAG]) return;
    root.dataset[FLAG] = '1';

    var revealEls = root.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(revealEls, function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    Array.prototype.forEach.call(revealEls, function (el) { io.observe(el); });
    root._nxCatCleanup = function () { io.disconnect(); };
  }

  function destroy(root) {
    if (root._nxCatCleanup) {
      root._nxCatCleanup();
      root._nxCatCleanup = null;
    }
    delete root.dataset[FLAG];
  }

  function initAll(scope) { roots(scope).forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // De Theme Editor vervangt secties zonder de pagina te herladen. Alleen
  // reageren op events met een echt element als target: een event dat op het
  // document zelf gericht is, zou anders elke instantie tegelijk opruimen.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || e.target.nodeType !== 1) return;
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || e.target.nodeType !== 1) return;
    roots(e.target).forEach(destroy);
  });
})();
